
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-partner",
      function () {
        return require("private-next-pages/become-a-partner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-partner"])
      });
    }
  